export const SPEED_TO_LEAD_METRICS_API_PATH = (communityId: number) =>
  `/recommendations/speed-to-lead/${communityId}/metrics/`;

export const SPEED_TO_LEAD_TOUCHPOINTS_API_PATH = (communityId: number, sourceCommunityId: number) =>
  `/recommendations/speed-to-lead/${communityId}/touchpoints/${sourceCommunityId}/`;

export const SPEED_TO_LEAD_SECONDS_PER_HOUR = 60 * 60;
export const SPEED_TO_LEAD_SECONDS_PER_MINUTE = 60;
export const SPEED_TO_LEAD_SUMMARY_MAX_ITEMS = 3;
export const SPEED_TO_LEAD_SCORE_RANGE = {
  MIN: 0,
  MAX: 100,
} as const;

export const SPEED_TO_LEAD_CONFIG_ID = {
  QUALITY: 62,
  SPEED: 63,
  OVERALL: 64,
  ACTION_PLANS: 65,
} as const;

export const SPEED_TO_LEAD_QUERY_KEY = {
  DETAILS: 'speed-to-lead-details',
  METRICS: 'speed-to-lead-metrics',
  TOUCHPOINT_PREVIEWS: 'speed-to-lead-touchpoint-previews',
  RECOMMENDATIONS: 'ai-competitive-intelligence-speed-to-lead',
} as const;

export const SPEED_TO_LEAD_FOLLOW_UP_VIEW = {
  CHANNEL: 'channel',
  SEQUENCE: 'sequence',
} as const;

export const SPEED_TO_LEAD_RANKING_VIEW = {
  OVERALL: 'overall',
  SPEED: 'speed',
  QUALITY: 'quality',
} as const;

export type SpeedToLeadRankingView = (typeof SPEED_TO_LEAD_RANKING_VIEW)[keyof typeof SPEED_TO_LEAD_RANKING_VIEW];

export const SPEED_TO_LEAD_RANKING_COPY: Record<SpeedToLeadRankingView, { title: string; description: string }> = {
  [SPEED_TO_LEAD_RANKING_VIEW.OVERALL]: {
    title: 'Overall Score',
    description:
      'Composite score blending speed (how quickly first contact was made across email and phone) and quality (channel coverage, personalization, and 7-day persistence). Weighted toward the channel mix that actually converts inquiries into tours.',
  },
  [SPEED_TO_LEAD_RANKING_VIEW.SPEED]: {
    title: 'Speed Score',
    description:
      'First response time, first-day outreach, and follow-up cadence — how fast and persistently a community reaches out once an inquiry comes in.',
  },
  [SPEED_TO_LEAD_RANKING_VIEW.QUALITY]: {
    title: 'Quality Score',
    description: 'Channel coverage, personalization, and 7-day persistence — what happens after the first touch lands.',
  },
};

export const SPEED_TO_LEAD_SECONDS_PER_DAY = 24 * SPEED_TO_LEAD_SECONDS_PER_HOUR;
export const SPEED_TO_LEAD_FOLLOW_UP_DAYS = [1, 2, 3, 4, 5, 6, 7];
export const SPEED_TO_LEAD_CHANNEL = { EMAIL: 'email', SMS: 'sms', CALL: 'call', VOICEMAIL: 'voicemail' } as const;
export const SPEED_TO_LEAD_CHANNEL_LABELS: Record<string, string> = {
  email: 'Email',
  call: 'Call',
  sms: 'SMS',
  voicemail: 'Call + Voicemail',
};
export const SPEED_TO_LEAD_COMMUNITY_OUTBOUND_DIRECTION = 'outbound';
export const SPEED_TO_LEAD_UNANSWERED_CALL_OUTCOMES = new Set(['missed', 'no_answer']);
export const SPEED_TO_LEAD_TOUCH_LABEL = 'touch';
export const SPEED_TO_LEAD_TOUCHES_LABEL = 'touches';
export const SPEED_TO_LEAD_NO_TOUCHES_LABEL = 'None';
export const SPEED_TO_LEAD_RECORDING_DOWNLOAD_TIMEOUT_MS = 30000;
export const SPEED_TO_LEAD_HTML_URL_CLEANUP_DELAY_MS = 1000;
export const SPEED_TO_LEAD_PLAYBACK_RATES = [1, 1.25, 1.5, 2];
export const SPEED_TO_LEAD_PROGRESS_STEP_SECONDS = 0.1;

export const SPEED_TO_LEAD_VOICEMAIL_DURATION_LABEL = 'Voicemail';
